/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { AllocatedTimeDTO } from '../models';
import { AssignMaterialToMaintenanceOrderDto } from '../models';
import { AvailableMaterialDto } from '../models';
import { ChangeMaintenanceOrderStatusDto } from '../models';
import { CloseMaintenanceOrderDto } from '../models';
import { CreateAllocationTimeDto } from '../models';
import { CreateMaintenanceOrderDto } from '../models';
import { MaintenanceOrderCreateFormOptionsDto } from '../models';
import { MaintenanceOrderDetailsDto } from '../models';
import { MaintenanceOrderTableDto } from '../models';
import { MaterialTableDto } from '../models';
import { RpsOptionDto } from '../models';
/**
 * MaintenanceOrdersApi - axios parameter creator
 * @export
 */
export const MaintenanceOrdersApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Allocate time to a maintenance order
     * @param {CreateAllocationTimeDto} body Allocation time data
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerAllocateTimeToMaintenanceOrder: async (
      body: CreateAllocationTimeDto,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling maintenanceOrdersControllerAllocateTimeToMaintenanceOrder.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerAllocateTimeToMaintenanceOrder.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}/allocate-time`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Asociar incidencias a una orden de mantenimiento
     * @param {Array<string>} body Identificadores de las incidencias
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerAssignIncidences: async (
      body: Array<string>,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling maintenanceOrdersControllerAssignIncidences.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerAssignIncidences.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}/incidences`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Assign a material to a maintenance order
     * @param {AssignMaterialToMaintenanceOrderDto} body
     * @param {string} maintenance_order_id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerAssignMaterialToMaintenanceOrder: async (
      body: AssignMaterialToMaintenanceOrderDto,
      maintenance_order_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling maintenanceOrdersControllerAssignMaterialToMaintenanceOrder.'
        );
      }
      // verify required parameter 'maintenance_order_id' is not null or undefined
      if (maintenance_order_id === null || maintenance_order_id === undefined) {
        throw new RequiredError(
          'maintenance_order_id',
          'Required parameter maintenance_order_id was null or undefined when calling maintenanceOrdersControllerAssignMaterialToMaintenanceOrder.'
        );
      }
      const localVarPath =
        `/maintenance-orders/{maintenanceOrderId}/materials`.replace(
          `{${'maintenanceOrderId'}}`,
          encodeURIComponent(String(maintenance_order_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Cambiar el estado de una orden de mantenimiento
     * @param {ChangeMaintenanceOrderStatusDto} body
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerChangeMaintenanceOrderStatus: async (
      body: ChangeMaintenanceOrderStatusDto,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling maintenanceOrdersControllerChangeMaintenanceOrderStatus.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerChangeMaintenanceOrderStatus.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}/status`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Close a maintenance order
     * @param {CloseMaintenanceOrderDto} body
     * @param {string} maintenance_order_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerCloseMaintenanceOrder: async (
      body: CloseMaintenanceOrderDto,
      maintenance_order_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling maintenanceOrdersControllerCloseMaintenanceOrder.'
        );
      }
      // verify required parameter 'maintenance_order_id' is not null or undefined
      if (maintenance_order_id === null || maintenance_order_id === undefined) {
        throw new RequiredError(
          'maintenance_order_id',
          'Required parameter maintenance_order_id was null or undefined when calling maintenanceOrdersControllerCloseMaintenanceOrder.'
        );
      }
      const localVarPath =
        `/maintenance-orders/{maintenanceOrderId}/close`.replace(
          `{${'maintenanceOrderId'}}`,
          encodeURIComponent(String(maintenance_order_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a maintenance order
     * @param {CreateMaintenanceOrderDto} body Maintenance order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerCreateMaintenanceOrder: async (
      body: CreateMaintenanceOrderDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling maintenanceOrdersControllerCreateMaintenanceOrder.'
        );
      }
      const localVarPath = `/maintenance-orders/maintenance-order`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a material from a maintenance order
     * @param {string} material_id Maintenance order material UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder: async (
      material_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'material_id' is not null or undefined
      if (material_id === null || material_id === undefined) {
        throw new RequiredError(
          'material_id',
          'Required parameter material_id was null or undefined when calling maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder.'
        );
      }
      const localVarPath = `/maintenance-orders/materials/{materialId}`.replace(
        `{${'materialId'}}`,
        encodeURIComponent(String(material_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Descargar el PDF de una orden de mantenimiento
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}/pdf`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all options required to create an incidence from RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetAllCreateFormOptions: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/maintenance-orders/create-options`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all maintenance orders with pagination and date filter
     * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
     * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
     * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetAllMaintenanceOrders: async (
      status?: string,
      date_from?: string,
      date_to?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/maintenance-orders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status;
      }

      if (date_from !== undefined) {
        localVarQueryParameter['dateFrom'] = date_from;
      }

      if (date_to !== undefined) {
        localVarQueryParameter['dateTo'] = date_to;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all times allocated to a maintenance order
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}/allocated-times`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Excluye los estados finales: finalizar una orden se hace por el cierre.
     * @summary Estados asignables a mano a una orden de mantenimiento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetAssignableStatusOptions: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/maintenance-orders/status-options`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     * Distributors get the stock of their assigned warehouse location; everyone else gets the post-sales warehouse.
     * @summary Get materials available in stock for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetAvailableMaterials: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/maintenance-orders/materials/available`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a maintenance order by ID
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetMaintenanceOrderDetailsById: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerGetMaintenanceOrderDetailsById.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all maintenance orders associated with an incidence
     * @param {string} incidence_id Incidence UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetMaintenanceOrdersByIncidence: async (
      incidence_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'incidence_id' is not null or undefined
      if (incidence_id === null || incidence_id === undefined) {
        throw new RequiredError(
          'incidence_id',
          'Required parameter incidence_id was null or undefined when calling maintenanceOrdersControllerGetMaintenanceOrdersByIncidence.'
        );
      }
      const localVarPath =
        `/maintenance-orders/incidence/{incidenceId}`.replace(
          `{${'incidenceId'}}`,
          encodeURIComponent(String(incidence_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all materials assigned to a maintenance order
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId.'
        );
      }
      const localVarPath = `/maintenance-orders/{id}/materials`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MaintenanceOrdersApi - functional programming interface
 * @export
 */
export const MaintenanceOrdersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Allocate time to a maintenance order
     * @param {CreateAllocationTimeDto} body Allocation time data
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerAllocateTimeToMaintenanceOrder(
      body: CreateAllocationTimeDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<AllocatedTimeDTO>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerAllocateTimeToMaintenanceOrder(
        body,
        id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Asociar incidencias a una orden de mantenimiento
     * @param {Array<string>} body Identificadores de las incidencias
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerAssignIncidences(
      body: Array<string>,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerAssignIncidences(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Assign a material to a maintenance order
     * @param {AssignMaterialToMaintenanceOrderDto} body
     * @param {string} maintenance_order_id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerAssignMaterialToMaintenanceOrder(
      body: AssignMaterialToMaintenanceOrderDto,
      maintenance_order_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<MaterialTableDto>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerAssignMaterialToMaintenanceOrder(
        body,
        maintenance_order_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Cambiar el estado de una orden de mantenimiento
     * @param {ChangeMaintenanceOrderStatusDto} body
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerChangeMaintenanceOrderStatus(
      body: ChangeMaintenanceOrderStatusDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerChangeMaintenanceOrderStatus(
        body,
        id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Close a maintenance order
     * @param {CloseMaintenanceOrderDto} body
     * @param {string} maintenance_order_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerCloseMaintenanceOrder(
      body: CloseMaintenanceOrderDto,
      maintenance_order_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerCloseMaintenanceOrder(
        body,
        maintenance_order_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Create a maintenance order
     * @param {CreateMaintenanceOrderDto} body Maintenance order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerCreateMaintenanceOrder(
      body: CreateMaintenanceOrderDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<MaintenanceOrderTableDto>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerCreateMaintenanceOrder(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Delete a material from a maintenance order
     * @param {string} material_id Maintenance order material UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder(
      material_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder(
        material_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Descargar el PDF de una orden de mantenimiento
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Blob>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById(
        id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all options required to create an incidence from RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAllCreateFormOptions(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<MaintenanceOrderCreateFormOptionsDto>>
    > {
      const localVarAxiosArgs =
        await MaintenanceOrdersApiAxiosParamCreator(
          configuration
        ).maintenanceOrdersControllerGetAllCreateFormOptions(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all maintenance orders with pagination and date filter
     * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
     * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
     * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAllMaintenanceOrders(
      status?: string,
      date_from?: string,
      date_to?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<MaintenanceOrderTableDto>>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerGetAllMaintenanceOrders(
        status,
        date_from,
        date_to,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all times allocated to a maintenance order
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<AllocatedTimeDTO>>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId(
        id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Excluye los estados finales: finalizar una orden se hace por el cierre.
     * @summary Estados asignables a mano a una orden de mantenimiento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAssignableStatusOptions(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<RpsOptionDto>>>
    > {
      const localVarAxiosArgs =
        await MaintenanceOrdersApiAxiosParamCreator(
          configuration
        ).maintenanceOrdersControllerGetAssignableStatusOptions(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     * Distributors get the stock of their assigned warehouse location; everyone else gets the post-sales warehouse.
     * @summary Get materials available in stock for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAvailableMaterials(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<AvailableMaterialDto>>>
    > {
      const localVarAxiosArgs =
        await MaintenanceOrdersApiAxiosParamCreator(
          configuration
        ).maintenanceOrdersControllerGetAvailableMaterials(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get a maintenance order by ID
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetMaintenanceOrderDetailsById(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<MaintenanceOrderDetailsDto>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerGetMaintenanceOrderDetailsById(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all maintenance orders associated with an incidence
     * @param {string} incidence_id Incidence UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetMaintenanceOrdersByIncidence(
      incidence_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<MaintenanceOrderTableDto>>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerGetMaintenanceOrdersByIncidence(
        incidence_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all materials assigned to a maintenance order
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<MaterialTableDto>>>
    > {
      const localVarAxiosArgs = await MaintenanceOrdersApiAxiosParamCreator(
        configuration
      ).maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId(
        id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * MaintenanceOrdersApi - factory interface
 * @export
 */
export const MaintenanceOrdersApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Allocate time to a maintenance order
     * @param {CreateAllocationTimeDto} body Allocation time data
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerAllocateTimeToMaintenanceOrder(
      body: CreateAllocationTimeDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<AllocatedTimeDTO>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerAllocateTimeToMaintenanceOrder(
          body,
          id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Asociar incidencias a una orden de mantenimiento
     * @param {Array<string>} body Identificadores de las incidencias
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerAssignIncidences(
      body: Array<string>,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerAssignIncidences(body, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Assign a material to a maintenance order
     * @param {AssignMaterialToMaintenanceOrderDto} body
     * @param {string} maintenance_order_id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerAssignMaterialToMaintenanceOrder(
      body: AssignMaterialToMaintenanceOrderDto,
      maintenance_order_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<MaterialTableDto>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerAssignMaterialToMaintenanceOrder(
          body,
          maintenance_order_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Cambiar el estado de una orden de mantenimiento
     * @param {ChangeMaintenanceOrderStatusDto} body
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerChangeMaintenanceOrderStatus(
      body: ChangeMaintenanceOrderStatusDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerChangeMaintenanceOrderStatus(
          body,
          id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Close a maintenance order
     * @param {CloseMaintenanceOrderDto} body
     * @param {string} maintenance_order_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerCloseMaintenanceOrder(
      body: CloseMaintenanceOrderDto,
      maintenance_order_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerCloseMaintenanceOrder(
          body,
          maintenance_order_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a maintenance order
     * @param {CreateMaintenanceOrderDto} body Maintenance order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerCreateMaintenanceOrder(
      body: CreateMaintenanceOrderDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<MaintenanceOrderTableDto>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerCreateMaintenanceOrder(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a material from a maintenance order
     * @param {string} material_id Maintenance order material UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder(
      material_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder(
          material_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Descargar el PDF de una orden de mantenimiento
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Blob>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById(
          id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all options required to create an incidence from RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAllCreateFormOptions(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<MaintenanceOrderCreateFormOptionsDto>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetAllCreateFormOptions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all maintenance orders with pagination and date filter
     * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
     * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
     * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAllMaintenanceOrders(
      status?: string,
      date_from?: string,
      date_to?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<MaintenanceOrderTableDto>>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetAllMaintenanceOrders(
          status,
          date_from,
          date_to,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all times allocated to a maintenance order
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<AllocatedTimeDTO>>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId(
          id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Excluye los estados finales: finalizar una orden se hace por el cierre.
     * @summary Estados asignables a mano a una orden de mantenimiento
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAssignableStatusOptions(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<RpsOptionDto>>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetAssignableStatusOptions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Distributors get the stock of their assigned warehouse location; everyone else gets the post-sales warehouse.
     * @summary Get materials available in stock for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetAvailableMaterials(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<AvailableMaterialDto>>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetAvailableMaterials(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a maintenance order by ID
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetMaintenanceOrderDetailsById(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<MaintenanceOrderDetailsDto>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetMaintenanceOrderDetailsById(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all maintenance orders associated with an incidence
     * @param {string} incidence_id Incidence UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetMaintenanceOrdersByIncidence(
      incidence_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<MaintenanceOrderTableDto>>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetMaintenanceOrdersByIncidence(
          incidence_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all materials assigned to a maintenance order
     * @param {string} id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<MaterialTableDto>>> {
      return MaintenanceOrdersApiFp(configuration)
        .maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId(
          id,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MaintenanceOrdersApi - object-oriented interface
 * @export
 * @class MaintenanceOrdersApi
 * @extends {BaseAPI}
 */
export class MaintenanceOrdersApi extends BaseAPI {
  /**
   *
   * @summary Allocate time to a maintenance order
   * @param {CreateAllocationTimeDto} body Allocation time data
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerAllocateTimeToMaintenanceOrder(
    body: CreateAllocationTimeDto,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<AllocatedTimeDTO>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerAllocateTimeToMaintenanceOrder(
        body,
        id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Asociar incidencias a una orden de mantenimiento
   * @param {Array<string>} body Identificadores de las incidencias
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerAssignIncidences(
    body: Array<string>,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerAssignIncidences(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Assign a material to a maintenance order
   * @param {AssignMaterialToMaintenanceOrderDto} body
   * @param {string} maintenance_order_id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerAssignMaterialToMaintenanceOrder(
    body: AssignMaterialToMaintenanceOrderDto,
    maintenance_order_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MaterialTableDto>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerAssignMaterialToMaintenanceOrder(
        body,
        maintenance_order_id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Cambiar el estado de una orden de mantenimiento
   * @param {ChangeMaintenanceOrderStatusDto} body
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerChangeMaintenanceOrderStatus(
    body: ChangeMaintenanceOrderStatusDto,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerChangeMaintenanceOrderStatus(
        body,
        id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Close a maintenance order
   * @param {CloseMaintenanceOrderDto} body
   * @param {string} maintenance_order_id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerCloseMaintenanceOrder(
    body: CloseMaintenanceOrderDto,
    maintenance_order_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerCloseMaintenanceOrder(
        body,
        maintenance_order_id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Create a maintenance order
   * @param {CreateMaintenanceOrderDto} body Maintenance order data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerCreateMaintenanceOrder(
    body: CreateMaintenanceOrderDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MaintenanceOrderTableDto>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerCreateMaintenanceOrder(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Delete a material from a maintenance order
   * @param {string} material_id Maintenance order material UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder(
    material_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerDeleteMaterialFromMaintenanceOrder(
        material_id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Descargar el PDF de una orden de mantenimiento
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Blob>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerDownloadMaintenanceOrdersPdfById(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all options required to create an incidence from RPS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetAllCreateFormOptions(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MaintenanceOrderCreateFormOptionsDto>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetAllCreateFormOptions(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all maintenance orders with pagination and date filter
   * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
   * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
   * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetAllMaintenanceOrders(
    status?: string,
    date_from?: string,
    date_to?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<MaintenanceOrderTableDto>>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetAllMaintenanceOrders(
        status,
        date_from,
        date_to,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all times allocated to a maintenance order
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<AllocatedTimeDTO>>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetAllocatedTimesByMaintenanceOrderId(
        id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Excluye los estados finales: finalizar una orden se hace por el cierre.
   * @summary Estados asignables a mano a una orden de mantenimiento
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetAssignableStatusOptions(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<RpsOptionDto>>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetAssignableStatusOptions(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   * Distributors get the stock of their assigned warehouse location; everyone else gets the post-sales warehouse.
   * @summary Get materials available in stock for the current user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetAvailableMaterials(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<AvailableMaterialDto>>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetAvailableMaterials(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get a maintenance order by ID
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetMaintenanceOrderDetailsById(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<MaintenanceOrderDetailsDto>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetMaintenanceOrderDetailsById(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all maintenance orders associated with an incidence
   * @param {string} incidence_id Incidence UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetMaintenanceOrdersByIncidence(
    incidence_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<MaintenanceOrderTableDto>>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetMaintenanceOrdersByIncidence(
        incidence_id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all materials assigned to a maintenance order
   * @param {string} id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MaintenanceOrdersApi
   */
  public async maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<MaterialTableDto>>> {
    return MaintenanceOrdersApiFp(this.configuration)
      .maintenanceOrdersControllerGetMaterialsByMaintenanceOrderId(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
